"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuatorPostRequest$ = exports.ValuatorPostRequest$outboundSchema = exports.ValuatorPostRequest$inboundSchema = void 0;
exports.valuatorPostRequestToJSON = valuatorPostRequestToJSON;
exports.valuatorPostRequestFromJSON = valuatorPostRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const valuatorpropertytype_js_1 = require("./valuatorpropertytype.js");
/** @internal */
exports.ValuatorPostRequest$inboundSchema = z.object({
    number_of_bedrooms: z.nullable(z.number().int()).optional(),
    property_type: z.nullable(valuatorpropertytype_js_1.ValuatorPropertyType$inboundSchema).optional(),
    street_group_property_id: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "number_of_bedrooms": "numberOfBedrooms",
        "property_type": "propertyType",
        "street_group_property_id": "streetGroupPropertyId",
    });
});
/** @internal */
exports.ValuatorPostRequest$outboundSchema = z.object({
    numberOfBedrooms: z.nullable(z.number().int()).optional(),
    propertyType: z.nullable(valuatorpropertytype_js_1.ValuatorPropertyType$outboundSchema).optional(),
    streetGroupPropertyId: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        numberOfBedrooms: "number_of_bedrooms",
        propertyType: "property_type",
        streetGroupPropertyId: "street_group_property_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ValuatorPostRequest$;
(function (ValuatorPostRequest$) {
    /** @deprecated use `ValuatorPostRequest$inboundSchema` instead. */
    ValuatorPostRequest$.inboundSchema = exports.ValuatorPostRequest$inboundSchema;
    /** @deprecated use `ValuatorPostRequest$outboundSchema` instead. */
    ValuatorPostRequest$.outboundSchema = exports.ValuatorPostRequest$outboundSchema;
})(ValuatorPostRequest$ || (exports.ValuatorPostRequest$ = ValuatorPostRequest$ = {}));
function valuatorPostRequestToJSON(valuatorPostRequest) {
    return JSON.stringify(exports.ValuatorPostRequest$outboundSchema.parse(valuatorPostRequest));
}
function valuatorPostRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ValuatorPostRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ValuatorPostRequest' from JSON`);
}
//# sourceMappingURL=valuatorpostrequest.js.map